import styled from 'styled-components';
import { themePalette } from './../../../../utils/theme-palette';

export const ItemContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xs};
  justify-content: space-between;
  align-items: center;

  &.selected {
    background-color: ${({ theme }) => theme.colors.seasalt};
    padding: ${({ theme }) => theme.spacing.s} 0;
    border-color: ${({ theme }) => theme.colors.platinum};
    border-width: 1px 0;
    border-style: solid;
    width: 100%;
  }
`;

export const ItemContent = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.m};
  width: 100%;
  align-items: center;
`;

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0 ${({ theme }) => theme.spacing.m};
  overflow: scroll;
  margin-bottom: ${({ theme }) => theme.spacing.m};
  padding-top: ${({ theme }) => theme.spacing.m};
`;

export const NoResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
  align-items: center;
`;

export const SearchTermContainer = styled.span`
  color: ${themePalette.lighgreen};
`;
